import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: 'members',
    canActivate: [AuthGuard],
    loadChildren: () => import('./report/report.module').then( m => m.ReportPageModule)
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'members/modalReportType',
    loadChildren: () => import('./modalContentReportType/modalContentReportType.module').then( m => m.ModalContentReportTypePageModule)
  },
  {
    path: 'members/reportAdd',
    loadChildren: () => import('./report-add/report-add.module').then( m => m.ReportAddPageModule)
  },
  {
    path: 'members/report1',
    loadChildren: () => import('./report1/report1.module').then( m => m.Report1PageModule)
  },
  {
    path: 'members/report-confirm',
    loadChildren: () => import('./report-confirm/report-confirm.module').then( m => m.ReportConfirmPageModule)
  },
  {
    path: 'members/report-signature',
    loadChildren: () => import('./report-signature/report-signature.module').then( m => m.ReportSignaturePageModule)
  },
  {
    path: 'members/report-accident',
    loadChildren: () => import('./report-accident/report-accident.module').then( m => m.ReportAccidentPageModule)
  }
  
   
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
